module.exports = __webpack_public_path__ + "static/media/admin.dc63456c.svg";